<template lang="pug">
.story-locations
  // Location search/add modal
  Modal(
    :story-id="storyId",
    :add-action="add",
    :disabled-location-ids="storyLocationsStore.locationIds"
  )

  ul.list-group.locations
    li.list-group-item.location(
      v-for="storyLocation in storyLocationsStore.storyLocations"
      :key="storyLocation.id"
    )
      span.pull-right(v-if="!readOnly")
        button.btn.btn-link.remove-location.text-muted(
          type="button"
          @click="remove(storyLocation.id)"
        )
          i.fa.fa-times

      router-link(
        :to="`/locations/${storyLocation.location.id}`"
      )
        i.fa.fa-map-marker
        |
        |
        | {{ storyLocation.location.title }}

      |
      |
      span.text-muted.small
        | {{ storyLocation.location.street1 }}

  .buttons.text-right(v-if="!readOnly")
    button.btn.btn-link(
      type="button"
      @click="openModal()"
      :disabled="disabled"
    )
      i.fa.fa-plus
      |
      | Add location
</template>

<script>
  import { mapStores } from 'pinia'
  import { useLocationsStore } from '../../../../stores/locations'
  import { useStoryLocationsStore } from '../../../../stores/story_locations'

  import Modal from './modal/index.vue'

  export default {
    components: {
      Modal
    },

    props: {
      storyId: {
        type: Number,
        required: true
      },

      readOnly: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        disabled: false
      }
    },

    computed: {
      ...mapStores(useLocationsStore),
      ...mapStores(useStoryLocationsStore)
    },

    async mounted() {
      this.fetchLocations()
    },

    methods: {
      async openModal() {
        this.locationsStore.showModal = true
      },

      async add({ locationId }) {
        const { storyId } = this

        await this.storyLocationsStore.create({ storyId, locationId })

        this.$store.dispatch('messages/addNotice', 'Location added')
      },

      async remove(id) {
        await this.storyLocationsStore.destroy({
          storyId: this.storyId,
          storyLocationId: id
        })

        this.$store.dispatch('messages/addNotice', 'Location removed')
      },

      async fetchLocations() {
        const { storyId } = this

        this.storyLocationsStore.fetch({ storyId })
      }
    }
  }
</script>

<style lang="scss">
  button.remove-location {
    // Keeps the Bootstrap .btn styling from throwing off the spacing
    padding: 0;
  }
</style>
